import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PlayIcon from "@heroicons/react/24/solid/PlayIcon";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";
import CurveArrow from "../../../assets/svg/curve-arrow.svg";

export const SkeletonContainer = styling("div")({
  width: "18.75rem",
  height: "13.5rem",
});

export const SocialMediaWrapper = styling("section")({
  position: "relative",
  width: "fit-content",
  padding: "2rem auto",

  "@media (max-width: 640px)": {
    width: "100%",
    padding: "1.5rem auto",
  },
});

export const CardContainer = styling(Box)((props) => ({
  display: "flex",
  gap: "1rem",
  width: "100%",

  "@media (max-width:640px)": {
    overflowX: "scroll",
    padding: "1.5rem 1rem 0",
  },
}));

export const ArrowContainer = styling("div")((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",

  position: "absolute",
  top: "-25px",
  left: "-45px",

  "@media (max-width: 640px)": {
    alignItems: props.$more ? "center" : "flex-end",
    flexDirection: props.$more ? "row-reverse" : "column",
    top: props.$more ? "-10px" : "40%",
    left: props.$more ? "70%" : "10%",
  },
}));

export const CardStyled = styling("div")({
  position: "relative",
  borderRadius: "0.5rem",
  border: `2px solid ${Color.black}`,
  height: "13.5rem",
  width: "7.5rem",

  transition: "box-shadow 0.1s ease-in-out, transform 0.1s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      cursor: "pointer",
      border: `2px solid ${Color.black}`,
      boxShadow: "4px 4px 0px rgba(0, 0, 0, 1)",
      transform: "translate(-4px, -4px)",
    },
  },

  "@media (max-width: 1280px)": {
    height: "11.15rem",
    maxWidth: "6.25rem",
    minWidth: "6.25rem",
    width: "100%",
  },
});

export const DialogStyled = styling(Dialog)({});

export const PlayIconStyled = styling(PlayIcon)({
  color: "#fff",
  opacity: "0.8",
  height: "2.5rem",
  width: "2.5rem",
});

export const FontAwesomeIconStyled = styling(FontAwesomeIcon)({
  position: "absolute",
  top: "0.5rem",
  left: "0.5rem",
  color: "#fff",
  height: "1.25rem",
  width: "1.25rem",
});

export const ArrowIcon = styling(CurveArrow)((props) => ({
  "@media (max-width: 640px)": {
    transform: props.$more ? "rotate(90deg)" : "rotate(-45deg)",
    margin: props.$more ? "0" : "-0.125rem -1rem 0 0",
  },
}));
